import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ShipmentAppEntityShipmentRead } from '../openapi';

export type ShipmentFilterValue = 'outgoing' | 'incoming' | 'all';

@Pipe({
  name: 'myCasesFilter',
  pure: true,
  standalone: true
})
export class MyCasesFilterPipe implements PipeTransform {
  transform(items: Array<ShipmentAppEntityShipmentRead>, value: ShipmentFilterValue): Array<ShipmentAppEntityShipmentRead> {
    switch (true) {
      case value === 'incoming': {
        return [...items.filter(v => v.incoming)]
          .sort((v1, v2) => {
            if (!v1.createdAt || !v2.createdAt) {
              return 0;
            } else {
              return new Date(v2.createdAt).getTime() - new Date(v1.createdAt).getTime();
            }
          });
      }
      case value === 'outgoing': {
        return [...items.filter(v => !v.incoming)]
          .sort((v1, v2) => {
            if (!v1.createdAt || !v2.createdAt) {
              return 0;
            } else {
              return new Date(v2.createdAt).getTime() - new Date(v1.createdAt).getTime();
            }
          });
      }
      default: {
        return [...items]
          .sort((v1, v2) => {
            if (!v1.createdAt || !v2.createdAt) {
              return 0;
            } else {
              return new Date(v2.createdAt).getTime() - new Date(v1.createdAt).getTime();
            }
          });
      }
    }
  }
}
